import { observer } from "mobx-react-lite";
import i from "../../../translations/i";
import controller from "./coupon.controller";
import { SelectUsersModal } from "../../../components/users/SelectUsersModal";

export const CouponExUsers = observer(() => {
  return(
    <SelectUsersModal
      selected={controller.selected_users}
      onSelect={(user: any) => controller.selectUser(user)}
      title={i.t('def:Coupon select users')}
    />
  )
})
